import { render, staticRenderFns } from "./FrequenciaMensal.vue?vue&type=template&id=3bdcb949&scoped=true&"
import script from "./FrequenciaMensal.vue?vue&type=script&lang=js&"
export * from "./FrequenciaMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcb949",
  null
  
)

export default component.exports